import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { LoaderService } from '@infrastructure/service/loader/loader.service';


@Component({
  selector: 'app-loader',
   standalone: true, // 👈 si lo estás usando standalone
  imports: [CommonModule], // 👈 aquí está el async pipe
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent {
  constructor(public loaderService: LoaderService) {}
}
